/**
 * PAGE HEADER
 * Header avec breadcrumb
 */

import { ChevronRight } from 'lucide-react';

interface Breadcrumb {
  label: string;
  href?: string;
}

interface PageHeaderProps {
  breadcrumbs: Breadcrumb[];
}

export function PageHeader({ breadcrumbs }: PageHeaderProps) {
  return (
    <div className="bg-white flex h-page-header min-h-page-header items-center justify-center w-full shrink-0">
      <div className="flex items-center gap-2.5 flex-grow px-page-padding">
        <div className="flex flex-wrap items-center gap-2.5">
          {breadcrumbs.map((crumb, index) => (
            <div key={index} className="flex items-center gap-2.5">
              {index > 0 && <ChevronRight className="size-[0.9375rem] text-zinc-500" />}
              <p
                className={`text-sm leading-5 ${
                  index === breadcrumbs.length - 1 ? 'text-zinc-700' : 'text-zinc-500'
                }`}
              >
                {crumb.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
